import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/qr/$qrLookupID/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/qr/$qrLookupID/welcome",
      params,
      search: { redirectFrom: Route.id },
    })
  },
})
